import BaseRequest from './BaseRequest';

const schema = 'setting';
/**
 * key base on host:port
 */
export default class SettingRequest extends BaseRequest {
  /**
	 *
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchCoinSettings() {
    const url = `${schema}/coin-settings`;
    return this.get(url);
  }

  fetchMarkets() {
    const url = `${schema}/markets`;
    return this.get(url);
  }

  fetchAllCoins() {
    const url = `${schema}/coins`;
    return this.get(url);
  }

  fetchLimitWithdrawal() {
    const url = `${schema}/limit-withdrawals`;
    return this.get(url);
  }

  fetchCryptoSetting() {
    const url = `${schema}/crypto-setting`;
    return this.get(url);
  }

  fetchSettingHash() {
    const url = `${schema}/setting-hash`;
    return this.get(url);
  }
}
